<canvas id="canvasLine">{{chart}}</canvas>